import WebComponent from '../base/WebComponent';

class EvalRelatedProducts extends WebComponent {
    currentProductId = null;
    relatedProducts = [];
    useClerk = false;
    areaId = 0;
    isFestival = false;

    getClerkRelatedProductsList() {
        const areaKey = this.getAreaKey();
        return `evaluering-${areaKey ? `${areaKey}-` : ""}visitor-recommendations`;
    }

    getAreaKey() {
        switch (parseInt(this.areaId)) {
            case 1:
                return "aarhus";
            case 2:
                return "emdrup";
            case 3:
                return "herning";
            case 4:
                return "odense";
            case 5:
                return "kolding";
            case 6:
                return "esbjerg";
            default:
                return '';
        }
    }

    mounted() {
            if (window.Clerk != null && this.useClerk && !this.isFestival) {
                setTimeout(() => {
                    window.Clerk('content','.clerk-recommendations');
                }, 50);
            }

        if (this.relatedProducts.length && !this.useClerk || this.relatedProducts.length && this.isFestival) {
            this.setTargetProps({target: 'w-product-carousel', props: {
                productList: this.relatedProducts
            }})
        }
    }

    template() {
        if (
            this.currentProductId && 
            [
                this.relatedProducts.length && !this.useClerk || this.relatedProducts.length && this.isFestival, 
                this.useClerk && !this.isFestival
            ].filter(item => item).length >= 1
        ) {
            return `
                <section class="pentary__bg">
                    <div class="initialOverflow" container>
                        <div grid="wrap">
                            <div column="s-12">
                                <h2 class="product-details__footer__title secondary__text">Kommende arrangementer</h2>
                                ${this.relatedProducts.length && !this.useClerk || this.relatedProducts.length && this.isFestival ? 
                                `<w-product-carousel></w-product-carousel>` : '' }
                                ${this.useClerk && !this.isFestival ? 
                                `<span class="clerk-recommendations" data-template="@${this.getClerkRelatedProductsList()}" data-products="[${this.currentProductId}]"></span>` : '' }
                            </div>
                        </div>
                    </div>
                </section>
            `;
        }
        return null;
    }
}

customElements.define( 'eval-related-products', EvalRelatedProducts );
